/** Glissement horizontal minimal, en px écran, pour changer de page : en deçà, c'est un tap. */
export const SWIPE_THRESHOLD_PX = 50

/** Au-delà de la première ou de la dernière page, la piste ne suit le doigt qu'au tiers. */
const EDGE_RESISTANCE = 3

/**
 * Page affichée après un glissement de (dx, dy) px depuis `page` : la suivante quand le doigt part
 * vers la gauche, la précédente vers la droite. Un geste trop court ou surtout vertical ne change
 * rien, et on reste dans les pages existantes.
 */
export const pageAfterSwipe = (page: number, pageCount: number, dx: number, dy: number): number => {
  if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dx) <= Math.abs(dy)) return page
  const target = dx < 0 ? page + 1 : page - 1
  return Math.min(pageCount - 1, Math.max(0, target))
}

/** Décalage suivi par la piste pendant le geste, freiné quand il n'y a pas de page de ce côté. */
export const swipeDragOffset = (page: number, pageCount: number, dx: number): number => {
  const pastEdge = (page === 0 && dx > 0) || (page === pageCount - 1 && dx < 0)
  return pastEdge ? dx / EDGE_RESISTANCE : dx
}
